// src/townsquare/project/types.ts
var TownsquareProjectAriResourceOwner = "townsquare", TownsquareProjectAriResourceType = "project";

export {
  TownsquareProjectAriResourceOwner,
  TownsquareProjectAriResourceType
};
